import React from "react";
import { node } from "prop-types";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import HeroLead from "@insightfulscience/atomic-react/Hero/Lead";
import { HeroCol, HeroRow } from "@insightfulscience/atomic-react/Hero/Grid";

const HeroTitleSectionGraphpad = ({ title, description }) => {
	return (
		<HeroRow spacing={{ mb: 10 }}>
			<HeroCol sm={12} md={9} sx={{ textAlign: "center" }}>
				<HeroTitle sx={{ fontColor: "white" }}>{title}</HeroTitle>
				<HeroLead>{description}</HeroLead>
			</HeroCol>
		</HeroRow>
	);
};

HeroTitleSectionGraphpad.propTypes = {
	title: node,
	description: node,
};

export default HeroTitleSectionGraphpad;
